var $fe3a4eb3eebfb0a2$exports = {};
$fe3a4eb3eebfb0a2$exports = {
    "dismiss": `Descartar`
};


export {$fe3a4eb3eebfb0a2$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
